import { handleActions } from 'redux-actions';

import { Actions } from '../actions/job-categories';

const initialState = {
  loading: false,
  error: null,
  value: [],
};

export default handleActions(
  {
    [Actions.JOB_CATEGORIES_REQUEST]: state => ({
      ...state,
      loading: true,
      error: null,
      value: [],
    }),
    [Actions.JOB_CATEGORIES_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      error: null,
      value: action.response.result,
    }),
    [Actions.JOB_CATEGORIES_FAILURE]: (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
      value: [],
    }),
  },
  initialState
);
